import React from "react";
import styled from "styled-components";
import { Button, StyledText } from "../../../../components/common";
import { useTheme } from "../../../../hooks";
import CautionIcon from "../../../../components/svgs/cautionIcon";

const ModalOverlay = styled.div`
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
`;

const ModalContent = styled.div`
  position: fixed;
  z-index: 100;
  width: 90%;
  bottom: 20%;
  left: 5%;
  right: 5%;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 15px;
`;

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 20px;
`;

const ReportModal = ({
  onBackDropClick,
  onReport,
  onCancel,
  title,
  description,
  action,
}) => {
  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  return (
    <>
      <ModalOverlay onClick={onBackDropClick} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CautionIcon
          width="49px"
          height="50px"
          fill={background}
          stroke="white"
        />
        <StyledText style={{ fontSize: 20 }}>{title}</StyledText>
        <StyledText
          style={{
            textAlign: "center",
            fontFamily: "MTNRegular",
            paddingInline: 15,
            marginTop: 10,
            color: "#7F7F7F",
          }}
        >
          {description}
        </StyledText>

        <ButtonContainer>
          <Button
            style={{
              backgroundColor: "white",
              width: "45%",
              border: "1.38px solid #333",
            }}
            onClick={onCancel}
          >
            <StyledText>Cancel</StyledText>
          </Button>
          <Button
            style={{ backgroundColor: background, width: "45%" }}
            onClick={onReport}
          >
            <StyledText color="white"> {action}</StyledText>
          </Button>
        </ButtonContainer>
      </ModalContent>
    </>
  );
};

export default ReportModal;
